import { useMemo } from 'react';
import logoSrc from '../assets/logo.png';

type ThemePalette = {
  primary: string;
  primaryAccent: string;
  secondary: string;
  secondaryAccent: string;
  background: string;
  backgroundAlt: string;
  text: string;
  textMuted: string;
};

const basePalette: ThemePalette = {
  primary: '#c89d3a',
  primaryAccent: '#e6b650',
  secondary: '#1d6d3b',
  secondaryAccent: '#2f8d53',
  background: '#fbfaf5',
  backgroundAlt: '#f6f1e2',
  text: '#2a2a2a',
  textMuted: '#5a5a5a',
};

const getCSSVariables = (palette: ThemePalette) => ({
  '--brand-primary': palette.primary,
  '--brand-primary-accent': palette.primaryAccent,
  '--brand-secondary': palette.secondary,
  '--brand-secondary-accent': palette.secondaryAccent,
  '--brand-surface': palette.background,
  '--brand-surface-alt': palette.backgroundAlt,
  '--brand-text': palette.text,
  '--brand-text-muted': palette.textMuted,
}) as React.CSSProperties;

const Header: React.FC = () => {
  const cssVars = useMemo(() => getCSSVariables(basePalette), []);

  return (
    <header className="brand-header" style={cssVars}>
      <div className="brand-header__safe-area" />
      <div className="brand-header__glow" aria-hidden="true" />
      <div className="brand-header__container group">
        <div className="brand-header__shimmer" aria-hidden="true" />
        <div className="brand-header__logo-wrapper" role="banner">
          <img
            src={logoSrc}
            alt="شعار جمعية البر الخيرية بمحافظة الحرَّة والشريك الاستراتيجي"
            className="brand-header__logo"
          />
        </div>
        <div className="brand-header__divider" aria-hidden="true" />
      </div>
    </header>
  );
};

export default Header;
